<script>
import { Modal,Dropdown } from "bootstrap";
export default {
  page: {},
  components: {  },
  props:{fixed_asset:Object },
  data() {
    return {
      currenciesArray: [],
      matchedAccounts: [],
      addPayAccounts: [{}],
      disposed_asset: {},
    
      remaining_value: 0,
      branches: [],
      branch_sites: [],
      fixedAssetProduct: {},
      revaluation_asset: {},
      registerAsset: [{}],
      // end global data
      fixedAssets: [],
      cash_accounts: [],
      typesOptions: [],
      cashAccounts: [],
      addAsset: [{}],
      // totalValue: 0,
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchBudget: null,
      isDepreciable: false,
      isRegisterDepreciable: false,
      classes: [],
      subclasses: [],
      SearchMode: false,
      search: "",
      // payment process data
      isOnCredit: true,
      selectedPaymentType: "",
      paymentTypes: [
        { id: 1, name: "مديونية", name_en: "Pay On Credit" },
        { id: 2, name: "دفع جزئي", name_en: "Partial Payment" },
        { id: 3, name: "دفع كامل", name_en: "Full Payment" },
      ],
      previous_payable: 0,
      prepayment: 0,
      due_date: null,
      is_du_time: false,
      // agent auto complete data :
      revaluate_value: {},
      // appprices:[]
      asset_revaluation_log_modal:{},
      revaluation_logs:[],
      log_page:1,
      log_limit:20,
      log_tot:0,
      dropdown:{},
filter:"all"
    };
  },
  computed: {
    
  },
  methods: {
   
  
    
    searchFixedAssetProducts(page) {
      if (this.search.length == 0) return this.cancelFixedAssetsSearchMode();

      this.SearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("fixed-assets/fixed-asset-products/disposed/search", {
          search: this.search,
          page,
          limit: this.limit,
          fixed_asset_id:this.$route.params.id,
          filter:this.filter
        })
        .then((res) => {
          if (res.status) {
            this.page = page;
            this.tot_pages = Math.ceil(res.tot / this.limit);
            this.fixedAssets = res.data;
          }
        });
    },
    cancelFixedAssetsSearchMode() {
      this.search = "";
      this.SearchMode = false;
      this.getFixedAssetProductsPagination(this.page);
    },
 
 

    getFixedAssetProductsPagination(page) {
      this.http
        .post("fixed-assets/fixed-asset-products/disposed/pagination", {
          limit: this.limit,
          page: page,
          fixed_asset_id:this.$route.params.id,
                    filter:this.filter

        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          console.log(this.tot_pages);
          this.fixedAssets = res.data;
          console.log("this.fixedAssets", this.fixedAssets);
        });
    },
 
 

  

  

    
   
        preAssetRevaluationLog(record){
      this.fixedAssetProduct = Object.assign({},record)  
      this.getRevaluationLogs(1)
      this.asset_revaluation_log_modal.show()
    },
      getRevaluationLogs(page){
      this.http.post('fixed-assets/revaluation-logs/pagination',{page,limit:this.log_limit,fixed_asset_product_id:this.fixedAssetProduct.id}).then((res) =>{

        if(res.status){
          this.log_page=page,
          this.log_tot=Math.ceil(res.tot / this.log_limit);
          this.revaluation_logs = res.data
        }
      })
    },
      searchRevaluationLogs(page){
      if(!this.log_search.length) return this.getRevaluationLogs(1)

      this.http.post('fixed-assets/revaluation-logs/search',{search:this.log_search,page,limit:this.log_limit,fixed_asset_product_id:this.fixedAssetProduct.id}).then((res) =>{

        if(res.status){
          this.log_page=page,
          this.log_tot=Math.ceil(res.tot / this.log_limit);
          this.revaluation_logs = res.data
        }
      })
    },
  },
  // end

  mounted() {
    console.log("fixed_asset :",this.fixed_asset);
    
    // const current_user = JSON.parse(localStorage.pos_station);
    // this.pos_station_id = current_user.pos_station_id;
    this.getFixedAssetProductsPagination(1);
    this.asset_revaluation_log_modal= new Modal('#assetRevaluationLogModal-1')
          this.dropdown = new Dropdown(".dropdown-toggle-disposed.filter-stock-disposed")


  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6 mb-4">
              <div class="search-box chat-search-box w-50">
                <div class="position-relative">
                  <input
                    @input="searchFixedAssetProducts(page)"
                    type="search"
                    class="form-control fa-lg text-light"
                    :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                    :placeholder="$t('popups.search')"
                    v-model="search"
                    style="background-color: #2a3042 !important"
                  />
                </div>
              </div>
            </div>
            <div class="col-6" style="display: flex; justify-content: flex-end">
                 <div class="">
                <div>
                    <div class="position-relative">
                        <input type="text" :value="$t(('fixed_assets.'+filter))" class="form-control" readonly>
                    </div>
                </div>
            </div>
          <div class="">
            <div class="dropdown">
            <button class="btn btn-light dropdown-toggle-disposed filter-stock-disposed" @click="dropdown.toggle" data-bs-toggle="dropdown" >
              <span class="fa fa-filter"></span>
            </button>
            <ul class="dropdown-menu" style="z-index:100">
              <li><a href="javascript: void(0)" class="dropdown-item" @click="filter='all'; search ? searchFixedAssetProducts(page): getFixedAssetProductsPagination(page)">{{$t("fixed_assets.all")}}</a></li>
              <li><a href="javascript: void(0)" class="dropdown-item" @click="filter='through_suppliers'; search ? searchFixedAssetProducts(page): getFixedAssetProductsPagination(page)">{{$t("fixed_assets.through_suppliers")}}</a></li>
              <li><a href="javascript: void(0)" class="dropdown-item" @click="filter='through_donations';  search ? searchFixedAssetProducts(page): getFixedAssetProductsPagination(page)">{{$t("fixed_assets.through_donations")}}</a></li>
             </ul>
            </div>
          </div>
            
            </div>
          </div>
          <div class="ant-table-content table-responsive">
          <table
              style="table-layout: auto"
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead class="ant-table-thead">
                <tr
                  class="text-light text-center"
                  style="background-color: #2a3042 !important"
                >
                  <th class=" ">#</th>
                                    <th scope="col">{{ $t("fixed_assets.code") }}</th>

                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.serial_no") }}
                    </span>
                  </th>
                                 <th scope="col">{{ $t("fixed_assets.supplier") }}</th>
                  <th scope="col">{{ $t("fixed_assets.donator") }}</th>
                  <th scope="col">{{ $t("emps.branch") }}</th>
                  <th scope="col">{{ $t("fixed_assets.branch_site") }}</th>

                  
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.initial") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluted_book_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.salvage_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluted_salvage_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.replacement_cost	") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluted_replacement_cost") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.depreciable") }}
                    </span>
                  </th>
                                    <!-- <th scope="col">{{ $t("fixed_assets.rate") }}</th> -->

                  <th class=" ">
                    {{ $t("fixed_assets.installation_date") }}
                  </th>
                  <th class=" ">
                    {{ $t("fixed_assets.revaluted_installation_date") }}
                  </th>
                  <th class=" ">
                    {{ $t("fixed_assets.useful_life_years") }}
                  </th>
                  <th class=" ">
                    {{ $t("fixed_assets.revaluted_useful_life_years") }}
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.under_warranty") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.warranty_exp") }}
                    </span>
                  </th>

                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.comment") }}
                    </span>
                  </th>
                  
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.operations") }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody class="ant-table-tbody">
                <tr
                  :title="
                    $i18n.locale == 'ar'
                      ? fixedAsset?.name
                      : fixedAsset?.name_en
                  "
                  v-for="(fixedAsset, index) in fixedAssets"
                  :key="index"
                  class="ant-table-row text-center ant-table-row-level-0"
                >
                  <td>{{ index + 1 }}</td>
                     <td class=" ">
                    {{ fixedAsset?.code }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.serial_no }}
                  </td>
                
          <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.agent_name
                        : fixedAsset?.agent_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.donator_name
                        : fixedAsset?.donator_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.branch_name
                        : fixedAsset?.branch_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.branch_site_name
                        : fixedAsset?.branch_site_name_en
                    }}
                  </td>

                  <td class=" ">
                    {{
                      parseFloat(
                        fixedAsset?.initial_book_value
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{

                    fixedAsset?.revaluted_book_value?  parseFloat(
                        fixedAsset?.revaluted_book_value
                      ).toLocaleString(): '-'
                    }}
                  </td>
                  <td class=" ">
                    {{
                      parseFloat(
                        fixedAsset?.salvage_value
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.revaluted_salvage_value ?
                      parseFloat(
                        fixedAsset?.revaluted_salvage_value
                      ).toLocaleString() :'-'
                    }}
                  </td>
                  <td class=" ">
                    {{
                      parseFloat(
                        fixedAsset?.replacement_cost
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.revaluted_replacement_cost ?
                      parseFloat(
                        fixedAsset?.revaluted_replacement_cost
                      ).toLocaleString() :'-'
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.depreciable
                        ? $t("fixed_assets.yes")
                        : $t("fixed_assets.no")
                    }}
                  </td>
                  <!--<td>
                    {{
                      fixedAsset?.depreciation_rate
                        ? fixedAsset?.depreciation_rate
                        : "-"
                    }}
                  </td> -->
                  <td class=" ">
                    {{ fixedAsset?.installation_date }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.revaluted_installation_date? fixedAsset?.revaluted_installation_date :'-' }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.useful_life_years ? parseFloat(fixedAsset?.useful_life_years) : '-' }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.revaluted_useful_life_years? parseFloat(fixedAsset?.useful_life_years) : '-' }}
                  </td>
                  
                  <td class=" ">
                    {{
                      fixedAsset?.under_warranty
                        ? $t("fixed_assets.yes")
                        : $t("fixed_assets.no")
                    }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.warranty_exp }}
                  </td>

                  <td class=" ">
                    {{ fixedAsset?.comment }}
                  </td>
                  
                  <td class=" ">
<router-link
                      style="margin-inline-end: 4px"
                     :to="{
                        name: 'fixed-asset-product-profile',
                        params: { id: fixedAsset?.fixed_asset_id,fixed_asset_product_id:fixedAsset?.id },
                      }"
                    >
                      <button
                        class="btn btn-info"
                        role="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="
                          $i18n.locale == 'ar'
                            ? fixedAsset.name
                            : fixedAsset.name_en +
                              ' - ' + fixedAsset.serial_no + ' ' +
                              $t('fixed_assets.profile')
                        "
                      >
                        <i class="bx bxs-detail"></i>
                      </button>
                    </router-link>
                    <button
                  
                      
                      style="margin-inline-end: 4px"
                      class="btn btn-primary btn-md"
                      @click="preAssetRevaluationLog(fixedAsset)"
                      > {{ $t("fixed_assets.asset_revaluation_log") }}
                    </button>
                
                   
                    
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--end-->
  
    <!--End register Modal-->

    <!--Start Edit Modal-->
    
    <!--End Edit Modal-->

    <!-- reEvaluteModal Modal End -->

    <!--   Apps  Pagination     -->
    <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="
              search
                ? searchFixedAssetProducts(page - 1)
                : getFixedAssetProductsPagination(page - 1)
            "
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="search ? searchFixedAssetProducts(p) : getFixedAssetProductsPagination(p)"
            >{{ p }}</a
          >
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="
              search
                ? searchFixedAssetProducts(page + 1)
                : getFixedAssetProductsPagination(page + 1)
            "
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>


  <div
    class="modal fade"
    id="assetRevaluationLogModal-1"
    tabindex="-1"
  
    role="dialog"
    aria-labelledby="modalTitleId"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalTitleId">
            {{$t('fixed_assets.asset_revaluation_log')}} / {{this.$i18n.locale=='en'? fixedAssetProduct.name_en :fixedAssetProduct.name }} - {{fixedAssetProduct.serial_no}}
          </h5>
        
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
            <div class="col-6 mb-4">
              <div class="search-box chat-search-box w-50">
                <div class="position-relative">
                  <input
                    @input="searchRevaluationLogs(log_page)"
                    type="search"
                    class="form-control fa-lg text-light"
                    :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                    :placeholder="$t('popups.search')"
                    v-model="log_search"
                    style="background-color: #2a3042 !important"
                  />
                </div>
              </div>
            </div>
          
          </div>
            <div class="table-responsive">
            <table
              style="table-layout: auto"
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead class="ant-table-thead">
                <tr
                  class="text-light text-center"
                  style="background-color: #2a3042 !important"
                >
                  <th class=" ">#</th>
                  
             
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluation_log.revaluation_date") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.reference_no") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluation_log.from_book_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluation_log.to_book_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluation_log.from_salvage_value") }}
                    </span>
                  </th>
                 
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluation_log.to_salvage_value") }}
                    </span>
                  </th>
                 
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluation_log.from_replacement_cost") }}
                    </span>
                  </th>
                 
                  <th class=" ">
                    <span class="ant-table-column-title"
                      >{{ $t("fixed_assets.revaluation_log.to_replacement_cost") }}
                    </span>
                  </th>
                 
                  <th class=" ">
                    {{ $t("fixed_assets.revaluation_log.from_useful_life_years") }}
                  </th>
                  
                  <th class=" ">
                    {{ $t("fixed_assets.revaluation_log.to_useful_life_years") }}
                  </th>
                  
                  <th class=" ">
                    {{ $t("fixed_assets.revaluation_log.from_installation_date") }}
                  </th>
                 
                  <th class=" ">
                    {{ $t("fixed_assets.revaluation_log.to_installation_date") }}
                  </th>
                </tr>
              </thead>
              <tbody class="ant-table-tbody">
                <tr
                  :title="
                    $i18n.locale == 'ar'
                      ? fixedAsset?.name
                      : fixedAsset?.name_en
                  "
                  v-for="(log, index) in revaluation_logs"
                  :key="index"
                  class="ant-table-row text-center ant-table-row-level-0"
                >
                  <td>{{ index + 1 }}</td>
                  <td class=" ">
                    {{ new Date(log?.created).toLocaleString("en-GB") }}
                  </td>
                  <td class=" ">
                    {{ log.reference_no }}
                  </td>
              

                  <td class=" ">
                    {{
                      parseFloat(
                        log?.from_book_value
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      parseFloat(
                        log?.to_book_value
                      ).toLocaleString()
                    }}
                  </td>

                  <td class=" ">
                    {{
                      parseFloat(
                        log?.from_salvage_value
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      parseFloat(
                        log?.to_salvage_value
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      parseFloat(
                        log?.from_replacement_cost
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      parseFloat(
                        log?.to_replacement_cost
                      ).toLocaleString()
                    }}
                  </td>
                
                  <td class=" ">
                    {{
                        log?.from_useful_life_years
                    }}
                  </td>
                
                  <td class=" ">
                    {{
                        log?.to_useful_life_years
                    }}
                  </td>
                
                  <td class=" ">
                    {{
                        log?.from_installation_date
                    }}
                  </td>
                  <td class=" ">
                    {{
                        log?.to_installation_date
                    }}
                  </td>
               


                
                  
                </tr>
              </tbody>
            </table>

            <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: log_page > 0 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="
              getRevaluationLogs(log_page - 1)
            "
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == log_page }"
          v-for="p in log_tot"
          :key="p"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click=" getRevaluationLogs(p)"
            >{{ p }}</a
          >
        </li>

        <li class="page-item" :class="{ disabled: log_page == log_tot }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="
           
                getRevaluationLogs(log_page + 1)
            "
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            @click="asset_revaluation_log_modal.hide()"
          >
            {{$t('popups.colse')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.purchase-container {
  background: #fafafa;
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}

.balance-table tr td {
  vertical-align: middle;
  padding: 12px 10px;
}
.balance-table tr th {
  vertical-align: middle;
  padding: 15px 10px;
}

.trash-icon-width {
  width: 24px;
}
</style>
